// extracted by mini-css-extract-plugin
module.exports = {"container":"Table_container__ZmGv_","scrollable":"Table_scrollable__2vVT7","table":"Table_table__37hOM","styledTable":"Table_styledTable__2v7O9"};